import messages from './messages.tsx';

export const restrictIssueLabel = messages.restrictIssue;
